/* eslint-disable import/no-mutable-exports */
import React from 'react';
import { Center, Image } from '@chakra-ui/react';
import { TTemplate } from '@/helpers/createTemplate';
import emptyBetslip from '../../../../../../../assets/betgalaxy/images/emptyBetslip.svg';

export const template: TTemplate = {
  wrapper: <Center />,
  empty: <Image src={emptyBetslip} boxSize="48" mixBlendMode="luminosity" />,
};

export default template;
